<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 min-h-screen">
        <div class="mb-8 flex flex-col items-center justify-center pt-8">
          <h1 class="text-[40px] text-primaryDark mb-2 text-center font-bold">
            Choose a plan that suits your team's learning needs
          </h1>
          <p class="text-[20px] text-textMuted text-center">
            Learn and explore new opportunities today!
          </p>
        </div>

        <PricingComponent />
      </main>
    </div>
  </div>
</template>

<script>
import PricingComponent from '@/components/pricing/PricingComponent.vue';
import Sidebar from '@/components/SidebarComponent.vue';

export default {
  name: 'PricingView',
  components: {
    PricingComponent,
    Sidebar,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>